module.exports = __webpack_public_path__ + "img/7g.f9996577.svg";